import { render, staticRenderFns } from "./ClientAddressLookup.vue?vue&type=template&id=40c1b9f4&scoped=true"
import script from "./ClientAddressLookup.vue?vue&type=script&lang=js"
export * from "./ClientAddressLookup.vue?vue&type=script&lang=js"
import style0 from "./ClientAddressLookup.vue?vue&type=style&index=0&id=40c1b9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c1b9f4",
  null
  
)

export default component.exports